import { getIsMacOs } from './get-is-mac-os';
import { getIsWindowsOs } from './get-is-windows-os';

export enum DesktopPlatform {
  Mac = 'mac',
  Windows = 'windows',
}

export const MAC_DOWNLOAD_URL =
  'https://storage.googleapis.com/griply-desktop-downloads/Griply-universal.dmg';
export const WINDOWS_DOWNLOAD_URL =
  'https://storage.googleapis.com/griply-desktop-downloads/Griply-Setup.exe';

export type DesktopDownloadTarget = {
  platform: DesktopPlatform;
  url: string;
};

export const getDesktopDownload = (): DesktopDownloadTarget | null => {
  if (getIsMacOs()) {
    return { platform: DesktopPlatform.Mac, url: MAC_DOWNLOAD_URL };
  }

  if (getIsWindowsOs()) {
    return { platform: DesktopPlatform.Windows, url: WINDOWS_DOWNLOAD_URL };
  }

  return null;
};
